function weboostClickMore() {
  var moreTextSection = document.getElementById('weboost-moretext-section');
  var moreLessButton = document.getElementById('weboost-moreless-button-id');
  
  moreTextSection.classList.toggle("weboost-toggle-display");
  
  if (moreLessButton.innerHTML.trim() === "Read more") {
    moreLessButton.innerHTML = "Read less";
  } else {
    moreLessButton.innerHTML = "Read more";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelectorAll(".collapsible-content__inner.rte")!=null){
      const collapsibleInners = document.querySelectorAll(".collapsible-content__inner.rte");
  
  collapsibleInners.forEach(inner => {
    const wrapper = inner.closest(".collapsibles-wrapper"); // 找到父级 .collapsibles-wrapper
    if (wrapper && !inner.innerHTML.trim()) {
      wrapper.style.display = "none";
    }
  });

  }


  if(document.querySelector(".shopify-section > div > .page-width--narrow > .theme-block > .rte") !=null){
     const inners = document.querySelector(".shopify-section > div > .page-width--narrow > .theme-block > .rte");
 const collapsibleInnersWrapper = inners.closest(".shopify-section");
  if (inners.innerHTML.trim() =="This section doesn’t currently include any content. Add content to this section using the sidebar.") {
      collapsibleInnersWrapper.style.display = "none";
    }
  }

});
